import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { buildLoginReturnPath } from "utils/loginRedirect";
import logo from "/Users/michaeltucker/Documents/coding-projects/client/src/assets/img/square-logo-with-text-v2.png";

function LoggedOutPrompt() {
  const location = useLocation();
  const returnPath = buildLoginReturnPath(location);

  useEffect(() => {
    document.body.classList.add("login-page");
    return () => document.body.classList.remove("login-page");
  }, []);

  return (
    <div className="auth-login-page">
      <div className="auth-login-brand">
        <Link to="/" className="auth-login-brand-link">
          <img
            src={logo}
            alt="Lesson Launchpad"
            className="auth-login-brand-logo"
          />
        </Link>
      </div>
      <div className="auth-login-panel">
        <div className="auth-login-panel-inner">
          <div className="auth-login-card">
            <h1 className="auth-login-title">You are logged out</h1>
            <p className="auth-login-subtitle">Log in to continue.</p>
            <Link
              to={{
                pathname: "/auth/login",
                state: { from: returnPath },
              }}
              className="btn design-system-primary-solid auth-login-submit"
            >
              Log in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoggedOutPrompt;
